// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__yvJUG","content":"ManualTimeModal_content__2EXOE"};